import React from 'react';

interface RingProps {
  children: React.ReactNode;
  className?: string;
}

export default function Ring({ children, className = "" }: RingProps) {
  return (
    <div className={`font-sans border border-[#e2e2e2] rounded-lg bg-white box-border ${className}`}>
      {children}
    </div>
  );
}
